import React, { useEffect, useState } from "react";
import "./ImageCombiner.scss";
interface ImageCombinerProps {
  qrcodeImage: string | any;
  logoSrc?: string | any;
  appendedText: null | string | undefined;
  category: string;
  description: string;
  assetId: string;
  subLocation: string;
  department: string;
  glCode: string;
}

const ImageCombiner: React.FC<ImageCombinerProps> = ({
  qrcodeImage,
  logoSrc,
  appendedText,
  category,
  description,
  assetId,
  subLocation,
  department,
  glCode,
}) => {
  const [showImageLogo, setShowImageLogo] = useState("");

  useEffect(() => {
    if (logoSrc) {
      setShowImageLogo(logoSrc);
    } else {
      setShowImageLogo("");
    }
  }, [logoSrc]);

  return (
    <div className="image-combiner">
      <div>
        {showImageLogo ? (
          <img className="images-logo" src={showImageLogo} alt="" />
        ) : (
          <div className="images-logo"></div>
        )}
      </div>

      <div className="append-details">
        <div
          style={{
            float: "inline-end",
          }}
        >
          <span>
            <img className="images-qrcode" src={qrcodeImage} alt="" />

            <p className="append-text">{appendedText}</p>
          </span>
        </div>
        <div>{glCode}</div>
        <div>{category}</div>
        <div>{department}</div>
        <div>{subLocation}</div>
        <div>{description}</div>
      </div>
    </div>
  );
};

export default ImageCombiner;
